import { render, staticRenderFns } from "./CreateUOMModal.vue?vue&type=template&id=343afc0d&scoped=true"
import script from "./CreateUOMModal.vue?vue&type=script&lang=js"
export * from "./CreateUOMModal.vue?vue&type=script&lang=js"
import style0 from "./CreateUOMModal.vue?vue&type=style&index=0&id=343afc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343afc0d",
  null
  
)

export default component.exports